<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-25 19:02:38
 * @LastEditors: 诺
 * @LastEditTime: 2022-11-03 11:03:12
 * @Description: file content
 -->

<template>
  <div>
      <ActBaseMusic v-if="$configInfo.backgroundMusicSwitch" :audioSrc="$configInfo.backgroundMusicUrl" />
    <router-view></router-view>
    <ActBaseAuthGuide v-if="$isSnapshotUser == 1" />
  </div>
</template>
<script>
import Vue from "vue/dist/vue.js";
// import wx from "weixin-js-sdk";
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {
    Vue.config.ignoredElements = ["wx-open-launch-weapp", "wx-open-launch-app"];



    // 用户来源：1原始链接 2二维码 3分享  目前没用到 后面考虑更新
    Vue.prototype.$fromType = "1";

    if (this.$userInfo) {
      let url = "";
      if (this.$avoidWeChatBug == 1) {
        url = `${this.$site}#/index?channel=${this.$channel}&fopenid=${this.$openid}&actCode=${this.$actCode}&fromSaleOpenId=${this.$fromSaleOpenId}&fuserId=${this.$fuserId}&fcorpId=${this.$fcorpId}&avoidWeChatBug=0`;
      } else {
        url = `${this.$site}#/index?channel=${this.$channel}&fopenid=${this.$openid}&actCode=${this.$actCode}&fromSaleOpenId=${this.$fromSaleOpenId}&fuserId=${this.$fuserId}&fcorpId=${this.$fcorpId}&avoidWeChatBug=1`;
      }
      this.$wx.setShare(null, null, url,null);
        this.$wx.sdk.miniProgram.getEnv(function(res) {
          console.log(res.miniprogram,'res.miniprogram') // true
          if(res.miniprogram){
            const locationUrl = new URL(window.location);
            locationUrl.searchParams.set('gzhOpenId', this.$openid);
            locationUrl.searchParams.set('actCode', this.$actCode);
            locationUrl.searchParams.set('customFlag', 0);
            locationUrl.searchParams.set('shareTitle', '');
            locationUrl.searchParams.set('shareImg', '');
            window.history.pushState({}, '', locationUrl);
          }
        })
      this.$wx.shareCallBackFunList.push("share1", () => {
        // this.configInfo.status == 3;
        console.log(this.$status)
        if(this.$status!==3){
          return
        }
        let url = this.$apizt.action.share;
        this.$httpzt.requestRestFul(url, {});
        this.$modal.share.close();
      });
    }
    if (this.$configInfo.shareSwitch!= 1) {
      this.$wx.hideOptionMenu();
    }
  },
  mounted() {},
};
</script>

<style lang="css" scoped></style>
